import type { UserAccessProfile } from "@pilatestime/shared-types";
import { queryOptions } from "@tanstack/react-query";
import api from "./api_client";

export const fetchAccessProfile = (
	token: string,
	organizationId: string,
): Promise<UserAccessProfile> => {
	if (!organizationId) {
		return Promise.reject(
			new Error("organizationId is required for fetchAccessProfile"),
		);
	}
	return api
		.get("/auth/profile/access", {
			params: { organizationId },
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
		.then((res) => res.data);
};

export const fetchAccessProfileQueryOptions = (
	userId: string,
	token: string,
	organizationId: string,
) =>
	queryOptions({
		queryKey: ["access_profile", userId, organizationId],
		queryFn: () => fetchAccessProfile(token, organizationId),
		staleTime: 2 * 60 * 1000,
	});
